import type { StaffUser } from "@/services/types";

/**
 * Ids of the seeded demonstration accounts. While the application runs on mock
 * data these accounts cannot be removed (deactivated or deleted), so testing
 * the user-management screen can never break the demo data the app relies on.
 * Newly created staff users are never protected.
 */
export const PROTECTED_STAFF_USER_IDS: string[] = [
  "u-super",
  "u-super2",
  "u-admin",
  "u-accountant",
  "u-collector",
  "u-collector2",
  "u-viewer",
  "u-deactivated",
];

/**
 * Staff users. Names match the staff who recorded receipts and closed auctions
 * in earlier phases, so the audit trail references records that actually exist.
 * Includes two Super Admins and one deactivated user so the account-protection
 * rules can be exercised.
 */
export const MOCK_STAFF_USERS: StaffUser[] = [
  {
    id: "u-super",
    name: "Ramesh Gupta",
    email: "ramesh@kametipro.in",
    phone: "+91 98100 12345",
    role: "super_admin",
    avatarColor: "#4f46e5",
    status: "active",
    lastLogin: "2026-08-25T09:12:00.000Z",
    createdAt: "2025-11-02T08:00:00.000Z",
  },
  {
    id: "u-super2",
    name: "Neha Verma",
    email: "neha@kametipro.in",
    phone: "+91 98210 99887",
    role: "super_admin",
    avatarColor: "#7c3aed",
    status: "active",
    lastLogin: "2026-08-24T16:40:00.000Z",
    createdAt: "2026-01-15T10:00:00.000Z",
  },
  {
    id: "u-admin",
    name: "Anita Desai",
    email: "admin@kametipro.in",
    phone: "+91 98200 22345",
    role: "admin",
    avatarColor: "#0d9488",
    status: "active",
    lastLogin: "2026-08-25T08:55:00.000Z",
    createdAt: "2025-12-01T09:00:00.000Z",
  },
  {
    id: "u-accountant",
    name: "Priya Sharma",
    email: "accounts@kametipro.in",
    phone: "+91 98400 42345",
    role: "accountant",
    avatarColor: "#0e7490",
    status: "active",
    lastLogin: "2026-08-25T09:05:00.000Z",
    createdAt: "2026-02-10T11:30:00.000Z",
  },
  {
    id: "u-collector",
    name: "Suresh Kumar",
    email: "collector@kametipro.in",
    phone: "+91 98300 32345",
    role: "collection_agent",
    avatarColor: "#d97706",
    status: "active",
    lastLogin: "2026-08-25T07:50:00.000Z",
    createdAt: "2025-12-20T14:00:00.000Z",
  },
  {
    id: "u-collector2",
    name: "Rajesh Iyer",
    email: "rajesh@kametipro.in",
    phone: "+91 98600 61234",
    role: "collection_agent",
    avatarColor: "#16a34a",
    status: "active",
    lastLogin: "2026-08-23T18:20:00.000Z",
    createdAt: "2026-03-01T09:30:00.000Z",
  },
  {
    id: "u-viewer",
    name: "Vikram Mehta",
    email: "viewer@kametipro.in",
    phone: "+91 98500 52345",
    role: "viewer",
    avatarColor: "#6b7280",
    status: "active",
    lastLogin: "2026-08-22T12:10:00.000Z",
    createdAt: "2026-04-05T10:00:00.000Z",
  },
  {
    id: "u-deactivated",
    name: "Pooja Singh",
    email: "pooja@kametipro.in",
    phone: "+91 98700 73456",
    role: "admin",
    avatarColor: "#db2777",
    status: "inactive",
    lastLogin: "2026-06-30T11:00:00.000Z",
    createdAt: "2025-12-10T09:00:00.000Z",
  },
];